import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { selectedPracticeArea } from '../appraisalComparisonCache';
import { useReactiveVar } from '@apollo/client';
import SkeletonWrapper from '../../shared/components/skeleton/SkeletonWrapper';

/**
 * @typedef {object} AppraisalCriteriaSectionProps
 * @property {Object} [data]
 * @property {boolean} [isPercentageVisible]
 * @property {number} [selectedAppraisalId]
 * @property {boolean} loading
 */

/**
 * @param {AppraisalCriteriaSectionProps} props
 */
const AppraisalCriteriaSection = props => {
  const { selectedAppraisalId, loading, isPercentageVisible = false, data: comparisonData } = props;

  const selectedPracticeAreaId = useReactiveVar(selectedPracticeArea);

  const [data, setData] = useState([]);

  useEffect(() => {
    if (comparisonData !== undefined && selectedAppraisalId) {
      const appraisalOrgUnits = get(
        comparisonData,
        'appraisalComparisonOrgUnit.AppraisalOrgUnits',
        []
      );
      const appraisalOrgUnit = appraisalOrgUnits.find(a => a.Appraisal.Id === selectedAppraisalId);
      const appraisalOrgUnitPracticeAreas = get(
        appraisalOrgUnit,
        'AppraisalOrgUnitTargetPracticeAreas',
        []
      );
      setData(appraisalOrgUnitPracticeAreas);

      if (appraisalOrgUnitPracticeAreas && appraisalOrgUnitPracticeAreas.length > 0) {
        selectedPracticeArea(appraisalOrgUnitPracticeAreas[0].PracticeArea.Id);
      }
    }
  }, [comparisonData, selectedAppraisalId]);

  return (
    <div id='appraisal-criteria-section'>
      <SkeletonWrapper show={loading}>
        <h4>Appraisal Criteria</h4>
        <p>
          Displays the Practice Areas (PA) and respective Practice Group Levels (PGL) appraised for
          the selected year with its Aggregate Percentage (%).
        </p>
      </SkeletonWrapper>
      <SkeletonWrapper show={loading} skeletonClassName='section-data-skeleton'>
        <table>
          <thead>
            <tr>
              <th>PA</th>
              <th>PGL</th>
              {isPercentageVisible && <th data-testid='appraisal-criteria-percentage-header'>%</th>}
            </tr>
          </thead>
          <tbody>
            {data.map((pa, index) => {
              const percentageDisplay =
                pa.AggregatePercentage !== null ? pa.AggregatePercentage : '';
              return (
                <tr
                  key={`${index}${selectedAppraisalId}`}
                  className={selectedPracticeAreaId == pa.PracticeArea.Id ? 'bold-selected' : ''}
                  onClick={() => selectedPracticeArea(pa.PracticeArea.Id)}
                  data-testid='appraisal-criteria-percentage-row'>
                  <td>
                    {pa.PracticeArea.Name} ({pa.PracticeArea.Acronym})
                  </td>
                  <td> {pa.PracticeGroup.Level}</td>
                  {isPercentageVisible && <td>{percentageDisplay}</td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </SkeletonWrapper>
    </div>
  );
};

export default AppraisalCriteriaSection;
